module.exports = __webpack_public_path__ + "static/img/shopping_cart_empty.c3a144d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopping_cart_empty.png
// module id = 3BXk
// module chunks = 1